/*-
 * ========================LICENSE_START=================================
 * TeamApps
 * ---
 * Copyright (C) 2014 - 2022 TeamApps.org
 * ---
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * 
 *      http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =========================LICENSE_END==================================
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 */
export const typescriptDeclarationFixConstant = 1;

import {UiClientObjectConfig} from "./UiClientObjectConfig";
import {UiQuery} from "./UiQuery";
import {UiComboBoxConfig} from "./UiComboBoxConfig";
import {UiTagComboBoxConfig} from "./UiTagComboBoxConfig";
import {UiChatDisplayConfig} from "./UiChatDisplayConfig";

export class QueryFunctionAdder {
	public static addQueryFunctionsToConfig(config: UiClientObjectConfig, queryCallback: (componentId: string, queryTypeId: string, queryObject: UiQuery) => Promise<any>) {
		switch (config._type) {
		    case "UiComboBox":
		    	    (config as UiComboBoxConfig).retrieveDropdownEntries = (queryObject: UiQuery) => queryCallback(config.id, "UiComboBox.retrieveDropdownEntries", queryObject);
		    	    (config as UiComboBoxConfig).lazyChildren = (queryObject: UiQuery) => queryCallback(config.id, "UiComboBox.lazyChildren", queryObject);
		    	break;
		    case "UiTagComboBox":
		    	    (config as UiTagComboBoxConfig).retrieveDropdownEntries = (queryObject: UiQuery) => queryCallback(config.id, "UiComboBox.retrieveDropdownEntries", queryObject);
		    	    (config as UiTagComboBoxConfig).lazyChildren = (queryObject: UiQuery) => queryCallback(config.id, "UiComboBox.lazyChildren", queryObject);
		    	break;
		    case "UiChatDisplay":
		    	    (config as UiChatDisplayConfig).requestContextMenu = (queryObject: UiQuery) => queryCallback(config.id, "UiChatDisplay.requestContextMenu", queryObject);
		    	    (config as UiChatDisplayConfig).requestPreviousMessages = (queryObject: UiQuery) => queryCallback(config.id, "UiChatDisplay.requestPreviousMessages", queryObject);
		    	break;
		}
	}
}
